const message = [
    {
        path: '/message/remind',
        name: 'messageRemind',
        component: () => import('@/view/message/remind'),
    },

]
export default message